import { css } from "styled-components";

export const BoxSizingStyle = css`
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`;
